import React, { useState } from "react";
import ModalPhoneNumber from "components/ModalPhoneNumber";
import useLoginStore from "hooks/useLoginStore";
import { API_PUT_MAMBOO } from "services";

/**
 * Endpoint update profile menerima seluruh objek profil, bukan sebagian field.
 * Karena itu payload dibangun ulang dari profil server dan hanya `phone_number`
 * yang ditimpa — supaya data lain tidak ikut terhapus.
 */
const buildProfilePayload = (profile, phoneNumber) => {
  const data = new FormData();
  const payload = {
    name: profile?.name || "",
    company_name: profile?.company_name || "",
    ip_base_number: profile?.ip_base_number || null,
    ip_name_number: profile?.ip_name_number || null,
    person_responsible: profile?.person_responsible || "",
    title: profile?.title || "",
    email: profile?.email || "",
    address: profile?.address || "",
    phone_number: phoneNumber,
    no_referal: profile?.no_referal || "",
    bank_data: {
      bank: profile?.bank_accounts?.bank || "",
      account_name: profile?.bank_accounts?.account_name || "",
      account_number: profile?.bank_accounts?.account_number || "",
    },
  };

  data.append("payload", JSON.stringify(payload));
  return data;
};

/**
 * Penjaga kelengkapan profil setelah login (Google maupun registrasi manual):
 *
 * Tugasnya tinggal satu: memunculkan modal wajib-isi nomor telepon selama
 * `phone_number` masih kosong.
 *
 * Pengalihan anggota non-member ke halaman draft kontrak sudah ditangani
 * `MemberProtected` di App.js, pada saat render — bukan lagi lewat useEffect
 * di sini yang baru berjalan setelah halaman sempat terlihat.
 */
const ProfileCompletionGate = () => {
  const serverProfile = useLoginStore((state) => state.serverProfile);
  const isLoadingServerProfile = useLoginStore((state) => state.isLoadingServerProfile);
  const fetchServerProfile = useLoginStore((state) => state.fetchServerProfile);

  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const isProfileReady = Boolean(serverProfile) && !isLoadingServerProfile;
  const hasPhoneNumber = Boolean(serverProfile?.phone_number);

  // Pengalihan anggota non-member ke halaman draft kontrak DIPINDAH ke
  // `MemberProtected` di App.js. Dulu dilakukan di sini lewat useEffect, yang
  // baru berjalan setelah halaman dirender — jadi dashboard sempat terlihat
  // dulu. Komponen ini kini hanya mengurus modal nomor telepon.

  const handleSavePhoneNumber = async (phoneNumber) => {
    setIsSaving(true);
    setErrorMessage("");

    try {
      await API_PUT_MAMBOO.update.updateProfile(
        buildProfilePayload(serverProfile, phoneNumber)
      );
      // Ambil ulang profil supaya modal tertutup dan pengecekan mamboo_id jalan.
      await fetchServerProfile();
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.data ||
          "Nomor telepon gagal disimpan. Silakan coba lagi."
      );
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ModalPhoneNumber
      isOpen={isProfileReady && !hasPhoneNumber}
      isSaving={isSaving}
      errorMessage={errorMessage}
      onSubmit={handleSavePhoneNumber}
    />
  );
};

export default ProfileCompletionGate;
